import GraduatedLoanBlock from './GraduatedLoanBlock';

export default GraduatedLoanBlock;
